import React, { Component } from "react";
import styles from "./taskTripSettings.module.scss";
import { withMonitoringTaskTrips } from "../../../../shared/containers/containerLogisticMonitoringsTaskTrips";
import Scrollbars from "react-custom-scrollbars-2";
import { withLogisticRoutes } from "../../../../shared/containers/containerLogisticRoutes";
import AddCircleOutlineIcon from "@mui/icons-material/AddCircleOutline";
import RemoveCircleOutlineIcon from "@mui/icons-material/RemoveCircleOutline";
import TooltipWrapper from "../../../../shared/items/contols/tooltipWrapper";
import ModalConfirmWindow from "../../../Contents/ModalComponents/ModalConfirmWindow";
import DeleteConfirm from "../../../Contents/ModalComponents/DeleteConfirm";
import ButtonPrimary from "../../../../shared/items/contols/buttonPrimary";
import { states } from "../../../../reducers/queriesStates";

class TaskTripRotesSettings extends Component {
  constructor(props) {
    super(props);

    this.state = {
      isOpenModal: false,
      routesToAdd: [],
      errorMessage: null,
    };
  }

  componentDidUpdate(preProps) {
    const { monitoringAddRoutesToTaskTripDataState, errors } = this.props;

    if (monitoringAddRoutesToTaskTripDataState === states.FAILURE && preProps.monitoringAddRoutesToTaskTripDataState === states.REQUEST) {
      const error = errors.data.split("\n\r")[0];

      if (error !== undefined) {
        this.setState({ errorMessage: error });
      }
    }
  }

  onAddhandleClick(route) {
    const { routesToAdd } = this.state;

    this.setState({ routesToAdd: routesToAdd.concat(route) });
  }

  onRemovehandleClick(route) {
    const { routesToAdd } = this.state;

    this.setState({
      routesToAdd: routesToAdd.filter((x) => {
        return x.id !== route.id;
      }),
    });
  }

  onSetAddRoutes() {
    const { onAddRoutesToTaskTrip, monitoringSettingsState } = this.props;
    const { routesToAdd } = this.state;

    onAddRoutesToTaskTrip({ routes: routesToAdd, ...monitoringSettingsState.routeState });
    this.setState({ isOpenModal: false });
  }

  render() {
    const { monitoringTaskTrip, monitoringSettingsState, logisticRoutes } = this.props;
    const { routesToAdd, isOpenModal, errorMessage } = this.state;

    if (monitoringTaskTrip === null || monitoringSettingsState.modificationType !== 1) return <div></div>;

    const height = window.innerHeight > 800 ? 600 : 400;

    const isButtonView =
      monitoringSettingsState.routeState !== null &&
      monitoringSettingsState.routeState.id != null &&
      monitoringSettingsState.routeState.unitId != null &&
      routesToAdd.length > 0;

    return (
      <div className={styles.taskTripRotesSettingsContainer}>
        <div className={styles.taskTripRotesPanel}>
          <div className={styles.panelContainer}>
            <b>Доступные маршруты</b>
            <div className={styles.taskTripRotesListContainer}>
              <Scrollbars style={{ height: `${height}px` }} autoHide={false} ref="scrollbar">
                {logisticRoutes.map((route, index) => {
                  const routeIsTrip = monitoringTaskTrip.units.some((unit) => {
                    const isSome = unit.routes.some((taskTripRoute) => {
                      return taskTripRoute.id == route.id;
                    });

                    if (isSome) return true;

                    return routesToAdd.some((routeToAdd) => {
                      return routeToAdd.id === route.id;
                    });
                  });

                  if (routeIsTrip) return null;
                  const timeEndLessCurrent = Date.parse(monitoringTaskTrip.timeEnd) > Date.parse(new Date().toISOString());
                  return (
                    <div
                      key={route.id}
                      className={styles.taskTripRotesItem}
                      style={{ backgroundColor: index % 2 === 0 ? "#90c0db18" : "white" }}
                    >
                      <div style={{ width: "45%" }}>{route.title}</div>
                      <div style={{ width: "45%" }}>{route.description}</div>

                      {timeEndLessCurrent ? (
                        <TooltipWrapper title={`Выбрать маршрут для добавления в рейс`} position="top">
                          <div
                            className={styles.taskTripRotesItemPlus}
                            onClick={(e) => {
                              e.stopPropagation();
                              this.onAddhandleClick(route);
                            }}
                          >
                            <AddCircleOutlineIcon fontSize="small" />
                          </div>
                        </TooltipWrapper>
                      ) : null}
                    </div>
                  );
                })}
              </Scrollbars>
            </div>
          </div>

          <div className={styles.panelContainer}>
            <b>Выбранные маршруты</b>
            <div className={styles.taskTripRotesListContainer}>
              <Scrollbars style={{ height: `${height}px` }} autoHide={false} ref="scrollbar">
                {routesToAdd.map((route, index) => {
                  return (
                    <div
                      key={route.id}
                      className={styles.taskTripRotesItem}
                      style={{ backgroundColor: index % 2 === 0 ? "#90c0db18" : "white" }}
                    >
                      <div style={{ width: "45%" }}>{route.title}</div>
                      <div style={{ width: "45%" }}>{route.description}</div>

                      <TooltipWrapper title={`Убрать маршрут`} position="top">
                        <div
                          className={styles.taskTripRotesItemPlus}
                          onClick={(e) => {
                            e.stopPropagation();
                            this.onRemovehandleClick(route);
                          }}
                        >
                          <RemoveCircleOutlineIcon fontSize="small" />
                        </div>
                      </TooltipWrapper>
                    </div>
                  );
                })}
              </Scrollbars>
            </div>
          </div>
        </div>

        {isButtonView && !monitoringSettingsState.isModificating && monitoringTaskTrip.taskTripModifications.length === 0 ? (
          <div className={styles.taskTripUnitsButtonContainer}>
            <ButtonPrimary
              handleClick={() => {
                this.setState({ isOpenModal: true });
              }}
              title={routesToAdd.length > 1 ? "Добавить маршруты к рейсу" : "Добавить маршрут к рейсу"}
            />
            {errorMessage !== null ? <div className={styles.errorMessage}>{errorMessage}</div> : null}
          </div>
        ) : null}

        {monitoringSettingsState.routeState !== null ? (
          <div>
            <ModalConfirmWindow isOpen={isOpenModal}>
              <DeleteConfirm
                onConfirmHandle={() => {
                  this.onSetAddRoutes();
                }}
                onNotConfirmHandle={(e) => {
                  this.setState({ isOpenModal: false });
                }}
                text={[
                  `Добавить маршруты к рейсу?`,
                  `Транспортное средство: ${monitoringSettingsState.routeState.unitTitle}`,
                  `Регистрационный номер: ${monitoringSettingsState.routeState.unitRegisterNumber}`,
                ]}
              />
            </ModalConfirmWindow>
          </div>
        ) : null}
      </div>
    );
  }
}

export default withLogisticRoutes(withMonitoringTaskTrips(React.memo(TaskTripRotesSettings)));
